import { encodeMultiApp } from '../../../solaris-lens-common-lib/src/utils/multiApp';
import { MULTI_APP_PARAM } from '../constants/multiApp';

/**
 * Builds target app URL with encoded current-app session (`?multiApp=`).
 * Works for any sending app that has a classic `accessToken` in session
 * (after OIDC mapping or username/password login).
 * @param {string} url target app home URL
 * @param {{ accessToken: string }} params
 * @returns {string}
 */
export const getExternalAppUrlWithMultiAppParams = (
  url,
  { accessToken } = {}
) => {
  if (!url) {
    return '';
  }

  const targetUrl = new URL(url);

  if (accessToken) {
    targetUrl.searchParams.set(MULTI_APP_PARAM, encodeMultiApp(accessToken));
  }

  return targetUrl.toString();
};

/**
 * Opens target app with encoded current session as URL params.
 * @param {{ url: string, accessToken: string }} params
 */
export const openExternalApp = ({ url, accessToken } = {}) => {
  if (!url || !accessToken) {
    return;
  }

  const urlWithParams = getExternalAppUrlWithMultiAppParams(url, {
    accessToken
  });

  window.open(urlWithParams, '_blank', 'noopener,noreferrer');
};
